/* Toubkal cart – timer + upsell "Add" knop. Werkt met de standaard Dawn cart-drawer. */
(function () {
  /* Reserveringstimer (10 min, per bezoeker) */
  var KEY = 'tk_cart_timer_end', DUR = 10 * 60 * 1000, endMem = null;
  function getEnd() {
    var e = null;
    try { e = parseInt(sessionStorage.getItem(KEY), 10); } catch (err) {}
    if (!e) e = endMem;
    if (!e || e < Date.now()) {
      e = Date.now() + DUR;
      endMem = e;
      try { sessionStorage.setItem(KEY, String(e)); } catch (err) {}
    }
    return e;
  }
  function tick() {
    var els = document.querySelectorAll('[data-tk-timer]');
    if (!els.length) return;
    var left = Math.max(0, getEnd() - Date.now());
    var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
    var txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    els.forEach(function (el) { el.textContent = txt; });
  }
  setInterval(tick, 1000); tick();

  /* Upsell toevoegen */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tk-add]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('[data-tk-upsell]');
    var input = card && card.querySelector('[data-tk-variant]');
    if (!input || !input.value) return;
    var drawer = document.querySelector('cart-drawer');
    btn.disabled = true; var label = btn.textContent; btn.textContent = 'Adding…';
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status && state.description) { alert(state.description); btn.disabled = false; btn.textContent = label; return; }
        if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(state);
        } else { window.location.href = '/cart'; }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tk-upsell', cartData: state }); } catch (err) {}
        }
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  });
})();

/* Gratis Mystery Gift: automatisch 1x in de cart zodra er een product in zit, weg als de cart verder leeg is. */
(function () {
  var GIFT_VARIANT = 53747003916554;
  var busy = false, queued = false;
  var origFetch = window.fetch.bind(window);

  function renderSilent(state) {
    if (!state || !state.sections) return;
    var parse = function (html, sel) { var d = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return d ? d.innerHTML : null; };
    var drawerHtml = state.sections['cart-drawer'];
    var bubbleHtml = state.sections['cart-icon-bubble'];
    var drawerEl = document.querySelector('#CartDrawer');
    var bubbleEl = document.getElementById('cart-icon-bubble');
    var drawer = document.querySelector('cart-drawer');
    if (drawerHtml && drawerEl) {
      var inner = parse(drawerHtml, '#CartDrawer');
      if (inner !== null) {
        drawerEl.innerHTML = inner;
        var ov = drawerEl.querySelector('#CartDrawer-Overlay');
        if (ov && drawer) ov.addEventListener('click', drawer.close.bind(drawer));
        if (drawer && typeof state.item_count === 'number') drawer.classList.toggle('is-empty', state.item_count === 0);
      }
    }
    if (bubbleHtml && bubbleEl) {
      var b = parse(bubbleHtml, '.shopify-section');
      if (b !== null) bubbleEl.innerHTML = b;
    }
  }

  function ensureGift() {
    if (busy) { queued = true; return; }
    busy = true;
    origFetch('/cart.js?t=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftQty = 0, giftKey = null, others = 0;
        cart.items.forEach(function (it) {
          if (it.variant_id === GIFT_VARIANT || it.id === GIFT_VARIANT) { giftQty += it.quantity; giftKey = it.key; }
          else others += it.quantity;
        });
        var want = others > 0 ? 1 : 0;
        if (giftQty === want) return null;
        var body, url;
        if (giftKey) { url = '/cart/change.js'; body = { id: giftKey, quantity: want }; }
        else { url = '/cart/add.js'; body = { items: [{ id: GIFT_VARIANT, quantity: 1 }] }; }
        body.sections = 'cart-drawer,cart-icon-bubble';
        body.sections_url = window.location.pathname;
        return origFetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            if (state && state.sections) {
              if (typeof state.item_count !== 'number') state.item_count = (others + (want ? 1 : 0));
              renderSilent(state);
              return;
            }
            /* /cart/add.js geeft geen item_count terug: sections apart ophalen */
            return origFetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
              .then(function (r) { return r.json(); })
              .then(function (sections) { renderSilent({ sections: sections, item_count: others + (want ? 1 : 0) }); });
          });
      })
      .catch(function () {})
      .then(function () { busy = false; if (queued) { queued = false; setTimeout(ensureGift, 300); } });
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(window, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(ensureGift, 250); }).catch(function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensureGift); else ensureGift();
})();
